import React, { MouseEvent } from 'react';
import { CheckBox } from 'kb-web-shared';
import PaymentTerms from '../../../components/Billing/components/TermsModal';
import {
  TermsBlock,
  TermsLink,
  TermsText,
  TermsTextContainer,
  TextContainer
} from './TermsDetails.common-styled';

type Props = {
  selected: boolean;
  onCheckBoxSelected: (e: MouseEvent<HTMLDivElement>) => void;
  type?: 'emailAndCredit' | 'credit';
};

type State = {
  modalVisible: boolean;
};

class TermsDetails extends React.Component<Props, State> {
  state: State = {
    modalVisible: false
  };

  showPaymentTerms = () => {
    this.setState({
      modalVisible: true
    });
  };

  render() {
    const { selected, onCheckBoxSelected, type = 'emailAndCredit' } = this.props;
    return (
      <TermsBlock>
        <PaymentTerms
          show={this.state.modalVisible}
          onAgree={() => {
            this.setState({
              modalVisible: false
            });
          }}
          onClose={() => {
            this.setState({
              modalVisible: false
            });
          }}
        />
        <CheckBox selected={selected} onSelect={onCheckBoxSelected} />
        <TextContainer>
          {type === 'emailAndCredit' && (
            <TermsTextContainer>
              <TermsText>
                I authorize Kindbody to send me secure communications, which may include my medical
                information. Kindbody only sends unencrypted text messages for appointment reminders
                and portal notifications.
              </TermsText>
            </TermsTextContainer>
          )}
          <TermsTextContainer>
            <TermsText>
              By clicking the button below, I agree that I have read and accept Kindbody’s{' '}
              <TermsLink
                href="https://kindbody.com/terms-of-service/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms of Use
              </TermsLink>
              ,{' '}
              <TermsLink
                href="https://kindbody.com/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </TermsLink>
              ,{' '}
              <TermsLink
                href="https://kindbody.com/notice-of-privacy-practices/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Notice of Privacy Practices
              </TermsLink>{' '}
              and <TermsLink onClick={this.showPaymentTerms}>Payment Terms.</TermsLink>
            </TermsText>
          </TermsTextContainer>
        </TextContainer>
      </TermsBlock>
    );
  }
}

export default TermsDetails;
